// Piccolo aiuto per creare elementi senza HTML scritto a mano (niente iniezioni: il testo resta testo).
export function h(tag, attributi = {}, ...figli) {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attributi || {})) {
    if (v === false || v == null) continue;
    if (k.startsWith('on') && typeof v === 'function') el.addEventListener(k.slice(2), v);
    else if (k === 'classe') el.className = v;
    else if (k === 'dati') Object.assign(el.dataset, v);
    else el.setAttribute(k, v === true ? '' : v);
  }
  for (const f of figli.flat(Infinity)) {
    if (f == null || f === false) continue;
    el.append(f instanceof Node ? f : String(f));
  }
  return el;
}

export function sostituisci(contenitore, ...figli) {
  contenitore.replaceChildren(...figli.flat(Infinity).filter(Boolean));
}

export const app = () => document.getElementById('app');

// Avviso breve in basso, che sparisce da solo.
export function avviso(testo) {
  const box = document.getElementById('avvisi');
  if (!box) return;
  const el = h('div', { classe: 'avviso', role: 'status' }, testo);
  box.append(el);
  setTimeout(() => el.remove(), 4000);
}

/**
 * Regola S1 (niente «falsi ok»): il messaggio di successo arriva solo con la conferma del server.
 * Se il server tarda (niente rete), dopo poco si dice che è salvato sul telefono e partirà da solo.
 * @param {Promise<{ ok: boolean, codice?: string }>} conferma da dati/prenotazioni.js
 * @param {string} testoOk messaggio da mostrare quando il server ha ricevuto
 * @param {{ telefono: string, errore: (codice: string) => string }} testi
 */
export function seguiInvio(conferma, testoOk, testi) {
  let finito = false;
  const attesa = setTimeout(() => { if (!finito) avviso(testi.telefono); }, 1500);
  return conferma.then(({ ok, codice }) => {
    finito = true;
    clearTimeout(attesa);
    avviso(ok ? testoOk : testi.errore(codice));
    return ok;
  });
}

// Foglio che sale dal basso (moduli e schede, come nel prototipo). Uno solo alla volta.
let foglioAperto = null;

/**
 * @param {{ sopra?: string, titolo: string, chiudi: string }} testi sopra = riga piccola sopra il titolo
 * @param {...Node} contenuto
 * @returns {{ foglio: HTMLElement, testa: HTMLElement, alChiudere: (f: () => void) => void }}
 */
export function apriFoglio({ sopra = '', titolo, chiudi }, ...contenuto) {
  chiudiFoglio();
  const testa = h('header', { classe: 'foglio-testa' },
    h('div', {}, h('p', { classe: 'sopra' }, sopra), h('h2', {}, titolo)),
    h('button', { type: 'button', classe: 'x', 'aria-label': chiudi, onclick: () => chiudiFoglio() }, '✕'));
  const foglio = h('section', { classe: 'foglio', id: 'foglio', role: 'dialog', 'aria-modal': 'true', 'aria-label': titolo }, testa, contenuto);
  const velo = h('div', { classe: 'velo', onclick: () => chiudiFoglio() });
  const tasti = (e) => { if (e.key === 'Escape') chiudiFoglio(); };
  document.addEventListener('keydown', tasti);
  document.body.append(velo, foglio);
  document.body.classList.add('con-foglio');
  foglioAperto = { foglio, velo, tasti, fine: [] };
  return { foglio, testa, alChiudere: (f) => foglioAperto?.fine.push(f) };
}

export function chiudiFoglio() {
  if (!foglioAperto) return;
  const { foglio, velo, tasti, fine } = foglioAperto;
  foglioAperto = null;
  document.removeEventListener('keydown', tasti);
  foglio.remove();
  velo.remove();
  document.body.classList.remove('con-foglio');
  for (const f of fine) f();
}

/**
 * Icona disegnata (SVG) come nella tela. Le forme sono scritte nel codice, mai testo dell'utente.
 * @param {Array<[string, object]>} forme es. [['rect', { x: 3, y: 5, width: 17, height: 15 }], ['path', { d: 'M3 10h17' }]]
 */
export function icona(forme) {
  const NS = 'http://www.w3.org/2000/svg';
  const crea = (tag, attr) => {
    const el = document.createElementNS(NS, tag);
    for (const [k, v] of Object.entries(attr)) el.setAttribute(k, v);
    return el;
  };
  const svg = crea('svg', {
    'aria-hidden': 'true', width: 22, height: 22, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
    'stroke-width': 1.8, 'stroke-linecap': 'round', 'stroke-linejoin': 'round',
  });
  svg.append(...forme.map(([tag, attr]) => crea(tag, attr)));
  return svg;
}
